module.exports = __webpack_public_path__ + "static/media/icon-renew-account-active.cd2d59f7.svg";